export function formatNumberInput(value) {
	// Buni inputni formatlash uchun
	if (!value && value !== 0) return value

	const stringValue = typeof value === 'string' ? value : String(value)

	const isNegative = stringValue.trim().startsWith('-')
	const numericValue = stringValue.replace(/[^\d.,]/g, '')

	const formatted = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
	return isNegative ? `-${formatted}` : formatted
}

export const removeSpaces = (value) => {
	if (!value) return ''
	const stringValue = typeof value === 'string' ? value : String(value)
	return stringValue.replace(/\s/g, '')?.replace(',', '.')
}

export default function formatNumber(value, locale = 'fr-FR', options = {}) {
	if (typeof value === 'string') {
		value = parseFloat(value)
	}

	if (isNaN(value)) {
		return ''
	}

	return new Intl.NumberFormat(locale, options).format(value)
}

export function limitTwoDecimals(value) {
	// Replace comma with dot for normalization
	let v = value.replace(',', '.')

	// Allow only numbers, dot, minus
	v = v.replace(/[^0-9.-]/g, '')

	// If more than one dot → keep only first
	const parts = v.split('.')
	if (parts.length > 2) {
		v = parts[0] + '.' + parts.slice(1).join('')
	}

	// Limit decimals to max 2 digits
	if (parts.length === 2) {
		v = parts[0] + '.' + parts[1].slice(0, 2)
	}

	return v
}
